(ns entities.priorities.specs
  (:require [cljs.spec.alpha :as s]))

(s/def ::id string?)
(s/def ::order (s/and integer? #(> % -1)))
(s/def ::title string?)

(s/def ::target-date (s/nilable string?))
(s/def ::feeling #{"VERY_DISSATISFIED"
                   "DISSATISFIED"
                   "NEUTRAL"
                   "SATISFIED"
                   "VERY_SATISFIED"})
(s/def ::goal (s/keys :req-un [::target-date
                               ::id
                               ::title
                               ::feeling]))
(s/def ::goals (s/coll-of ::goal))

(s/def :patch/goal (s/keys :req-un [
                                    ::target-date
                                    ::title
                                    ::feeling
                                    ]))
(s/def :patch/goals (s/coll-of :patch/goal))
(s/def ::patch (s/keys ::req-un [
                                 ::title
                                 ::order
                                 :patch/goals
                                 ]))

(s/def ::priority (s/keys :req-un [::id
                                   ::order
                                   ::title
                                   ::goals]))

